import request from '@/utils/request'
import { getDetectToken } from "@/utils/auth.js"
import axios from 'axios'

/**
 * 查询该登录账号下的公司列表
 */
export function queryClientList() {
  return request({
    url: '/smart/health/api/pas/platform/client/queryChildrenList',
    method: 'post'
  })
}

/**
 * 图片下载 模块api
 */
export function imageDownload(data) {
    let baseUrl = process.env.BASE_API;
    for(let key in data) {
      if(data[key] === "") {
        delete data[key]
      }
    }
    return axios.post(baseUrl + '/smart/health/api/dcs/File/Upload/downloadDetectImage', data, {
      headers: {
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
        'detecttoken': getDetectToken(),
      },
      responseType: 'blob' 
    })
}


// WEBPACK FOOTER //
// ./src/api/common.js